import { render } from "./trading.vue?vue&type=template&id=3ab8d96e"
import script from "./trading.vue?vue&type=script&lang=js"
export * from "./trading.vue?vue&type=script&lang=js"

import "./trading.vue?vue&type=style&index=0&id=3ab8d96e&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__